import styled from 'styled-components';

export const InformationWrapper = styled.div`
  margin: 2.5rem 0;
`;
